export default __webpack_public_path__ + "static/media/WarmonkPassageMap.0747c4df.jpg";